import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const parametrizacaoEditaisRoutes: Routes = [
  {
    path: 'ciclos',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: ':id/vincular-vagas',
        data: {
          title: 'Vincular vagas ao ciclo',
          roles: [Role.VAGAS_EDITAR],
          breadcrumb: [
            { label: 'Ciclos', url: '/ciclos' },
            { label: 'Vincular vagas' },
          ],
        },
        loadComponent: () =>
          import('./steps/carga-inicial/vincular-vagas/vincular-vagas.component').then(
            (m) => m.VincularVagasComponent,
          ),
      },
      {
        path: ':cicloId/historico',
        data: {
          title: 'Histórico do Ciclo',
          roles: [Role.PROGRAMA_CONSULTAR],
          breadcrump: [
            { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
            { label: 'Histórico do Ciclo' },
          ],
        },
        loadComponent: () =>
          import('./historico-ciclo/historico-ciclo.component').then(
            (m) => m.HistoricoCicloComponent,
          ),
      },
    ],
  },
  {
    path: 'parametrizacao-editais',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./parametrizacao-editais.component').then(
            (m) => m.ParametrizacaoEditaisComponent,
          ),
        data: {
          title: 'Parametrização de Editais',
          roles: [Role.PROGRAMA_CONSULTAR],
          breadcrumb: [
            { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
          ],
        },
      },
      {
        path: 'perguntas',
        canActivateChild: [RoleChildGuard],
        data: {
          title: 'Gerenciar Perguntas',
          breadcrumb: [
            { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
            { label: 'Gerenciar Perguntas' },
          ],
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../perguntas/perguntas.component').then(
                (m) => m.PerguntasComponent,
              ),
            data: {
              title: 'Perguntas do Edital',
              roles: [Role.PERGUNTA_CONSULTAR],
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Gerenciar Perguntas', url: '/parametrizacao-editais/perguntas' },
              ],
            },
          },
          {
            path: 'cadastrar',
            data: {
              title: 'Cadastrar Pergunta',
              roles: [Role.PERGUNTA_CADASTRAR],
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Gerenciar Perguntas', url: '/parametrizacao-editais/perguntas' },
                { label: 'Cadastrar', url: '/parametrizacao-editais/perguntas/cadastrar' },
              ],
            },
            loadComponent: () =>
              import('../perguntas/pergunta-form/pergunta-form.component').then(
                (m) => m.PerguntaFormComponent,
              ),
          },
          {
            path: 'editar/:id',
            data: {
              title: 'Editar Pergunta',
              roles: [Role.PERGUNTA_EDITAR],
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Gerenciar Perguntas', url: '/parametrizacao-editais/perguntas' },
                { label: 'Editar', url: '/parametrizacao-editais/perguntas/editar' },
              ],
            },
            loadComponent: () =>
              import('../perguntas/pergunta-form/pergunta-form.component').then(
                (m) => m.PerguntaFormComponent,
              ),
          },
        ],
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./wizard.component').then((m) => m.WizardComponent),
        data: {
          title: 'Parametrização de Editais',
          roles: [Role.PROGRAMA_CADASTRAR],
          breadcrumb: [
            { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
            { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
          ],
        },
        children: [
          {
            path: '',
            redirectTo: 'ciclo',
            pathMatch: 'full',
          },
          {
            path: 'ciclo',
            data: {
              title: 'Parametrização de Editais: Ciclo',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                { label: 'Ciclo', url: '/parametrizacao-editais/cadastrar/ciclo' },
              ],
            },
            loadComponent: () =>
              import('./steps/ciclo/ciclo-step.component').then(
                (m) => m.CicloStepComponent,
              ),
          },
          {
            path: ':cicloId',
            children: [
              {
                path: '',
                redirectTo: 'vedacoes',
                pathMatch: 'full',
              },
              {
                path: 'vedacoes',
                data: {
                  title: 'Parametrização de Editais: Vedações',
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                    { label: 'Vedações', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('./steps/vedacoes/vedacoes-step.component').then(
                    (m) => m.VedacoesStepComponent,
                  ),
              },
              {
                path: 'carga-inicial',
                data: {
                  title: 'Parametrização de Editais: Carga Inicial',
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                    { label: 'Carga Inicial', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('./steps/carga-inicial/carga-inicial-step.component').then(
                    (m) => m.CargaInicialStepComponent,
                  ),
              },
              {
                path: 'selecao-ine',
                data: {
                  title: 'Parametrização de Editais: Seleção de INE',
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                    { label: 'Seleção de INE', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('./steps/selecao-ine/selecao-ine-step.component').then(
                    (m) => m.SelecaoIneStepComponent,
                  ),
              },
              {
                path: 'fases',
                data: {
                  title: 'Parametrização de Editais: Fases',
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                    { label: 'Fases', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('./steps/fases/fases-step.component').then(
                    (m) => m.FasesStepComponent,
                  ),
              },
              {
                path: 'cronograma',
                data: {
                  title: 'Parametrização de Editais: Cronograma',
                  roles: [Role.CRONOGRAMA_CADASTRAR],
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                    { label: 'Cronograma', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('./steps/cronograma/cronograma-step.component').then(
                    (m) => m.CronogramaStepComponent,
                  ),
              },
              {
                path: 'documentos',
                data: {
                  title: 'Parametrização de Editais: Documentos',
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                    { label: 'Documentos', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('./steps/documentos/documentos-fases-etapas-step.component').then(
                    (m) => m.DocumentoFaseEtapaStepComponent,
                  ),
              },
              {
                path: 'perguntas',
                data: {
                  title: 'Parametrização de Editais: Perguntas',
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                    { label: 'Perguntas', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('./steps/perguntas/perguntas-step.component').then(
                    (m) => m.PerguntasStepComponent,
                  ),
              },
              {
                path: 'barema',
                children: [
                  {
                    path: '',
                    data: {
                      title: 'Parametrização de Editais: Barema',
                      breadcrumb: [
                        { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                        { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                        { label: 'Barema', url: '' },
                      ],
                    },
                    loadComponent: () =>
                      import('./steps/barema/barema-step.component').then(
                        (m) => m.BaremaStepComponent,
                      ),
                  },
                  {
                    path: 'item/:itemId/profissionais',
                    data: {
                      title: 'Profissionais por Item',
                      roles: [Role.BAREMA_CONSULTAR],
                      breadcrumb: [
                        { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                        { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                        { label: 'Barema', url: '' },
                        { label: 'Profissionais por Item', url: '' },
                      ],
                    },
                    loadComponent: () =>
                      import('../gerenciar-barema/profissionais-por-item/profissionais-por-item.component').then(
                        (m) => m.ProfissionaisPorItemComponent,
                      ),
                  },
                  {
                    path: 'item/:itemId/upload/:uploadId/profissionais',
                    data: {
                      title: 'Profissionais Identificados',
                      roles: [Role.BAREMA_CONSULTAR],
                      breadcrumb: [
                        { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                        { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                        { label: 'Barema', url: '' },
                        { label: 'Profissionais Identificados', url: '' },
                      ],
                    },
                    loadComponent: () =>
                      import('../gerenciar-barema/profissionais-identificados/profissionais-identificados.component').then(
                        (m) => m.ProfissionaisIdentificadosComponent,
                      ),
                  },
                ],
              },
              {
                path: 'final',
                data: {
                  title: 'Parametrização de Editais: Final',
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Cadastrar', url: '/parametrizacao-editais/cadastrar' },
                    { label: 'Final', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('./steps/final/final-step.component').then(
                    (m) => m.FinalStepComponent,
                  ),
              },
            ],
          },
        ],
      },
      {
        path: 'editar/:cicloId',
        loadComponent: () =>
          import('./wizard.component').then((m) => m.WizardComponent),
        data: {
          title: 'Editar Ciclo',
          roles: [Role.PROGRAMA_EDITAR],
          breadcrumb: [
            { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
            { label: 'Editar', url: '' },
          ],
        },
        children: [
          {
            path: '',
            redirectTo: 'ciclo',
            pathMatch: 'full',
          },
          {
            path: 'ciclo',
            data: {
              title: 'Ciclo',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Editar', url: '' },
                { label: 'Ciclo', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/ciclo/ciclo-step.component').then(
                (m) => m.CicloStepComponent,
              ),
          },
          {
            path: 'vedacoes',
            data: {
              title: 'Parametrização de Editais',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Editar', url: '' },
                { label: 'Vedações', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/vedacoes/vedacoes-step.component').then(
                (m) => m.VedacoesStepComponent,
              ),
          },
          {
            path: 'carga-inicial',
            data: {
              title: 'Carga Inicial',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Editar', url: '' },
                { label: 'Carga Inicial', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/carga-inicial/carga-inicial-step.component').then(
                (m) => m.CargaInicialStepComponent,
              ),
          },
          {
            path: 'selecao-ine',
            data: {
              title: 'Seleção de INE',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Editar', url: '' },
                { label: 'Seleção de INE', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/selecao-ine/selecao-ine-step.component').then(
                (m) => m.SelecaoIneStepComponent,
              ),
          },
          {
            path: 'fases',
            data: {
              title: 'Fases',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Editar', url: '' },
                { label: 'Fases', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/fases/fases-step.component').then(
                (m) => m.FasesStepComponent,
              ),
          },
          {
            path: 'cronograma',
            data: {
              title: 'Cronograma',
              roles: [Role.CRONOGRAMA_EDITAR],
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Editar', url: '' },
                { label: 'Cronograma', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/cronograma/cronograma-step.component').then(
                (m) => m.CronogramaStepComponent,
              ),
          },
          {
            path: 'documentos',
            data: {
              title: 'Documentos',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Editar', url: '' },
                { label: 'Documentos', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/documentos/documentos-fases-etapas-step.component').then(
                (m) => m.DocumentoFaseEtapaStepComponent,
              ),
          },
          {
            path: 'perguntas',
            data: {
              title: 'Perguntas',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Editar', url: '' },
                { label: 'Perguntas', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/perguntas/perguntas-step.component').then(
                (m) => m.PerguntasStepComponent,
              ),
          },
          {
            path: 'barema',
            children: [
              {
                path: '',
                data: {
                  title: 'Barema',
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Editar', url: '' },
                    { label: 'Barema', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('./steps/barema/barema-step.component').then(
                    (m) => m.BaremaStepComponent,
                  ),
              },
              {
                path: 'item/:itemId/profissionais',
                data: {
                  title: 'Profissionais por Item',
                  roles: [Role.BAREMA_CONSULTAR],
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Editar', url: '' },
                    { label: 'Barema', url: '' },
                    { label: 'Profissionais por Item', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('../gerenciar-barema/profissionais-por-item/profissionais-por-item.component').then(
                    (m) => m.ProfissionaisPorItemComponent,
                  ),
              },
              {
                path: 'item/:itemId/upload/:uploadId/profissionais',
                data: {
                  title: 'Profissionais Identificados',
                  roles: [Role.BAREMA_CONSULTAR],
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Editar', url: '' },
                    { label: 'Barema', url: '' },
                    { label: 'Profissionais Identificados', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('../gerenciar-barema/profissionais-identificados/profissionais-identificados.component').then(
                    (m) => m.ProfissionaisIdentificadosComponent,
                  ),
              },
            ],
          },
          {
            path: 'final',
            data: {
              title: 'Final',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Editar', url: '' },
                { label: 'Final', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/final/final-step.component').then(
                (m) => m.FinalStepComponent,
              ),
          },
        ],
      },
      {
        path: 'visualizar/:cicloId',
        loadComponent: () =>
          import('./wizard.component').then((m) => m.WizardComponent),
        data: {
          title: 'Visualizar Ciclo',
          roles: [Role.PROGRAMA_CONSULTAR],
          breadcrumb: [
            { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
            { label: 'Visualizar', url: '' },
          ],
        },
        children: [
          {
            path: '',
            redirectTo: 'ciclo',
            pathMatch: 'full',
          },
          {
            path: 'ciclo',
            data: {
              title: 'Ciclo',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Visualizar', url: '' },
                { label: 'Ciclo', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/ciclo/ciclo-step.component').then(
                (m) => m.CicloStepComponent,
              ),
          },
          {
            path: 'vedacoes',
            data: {
              title: 'Vedações',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Visualizar', url: '' },
                { label: 'Vedações', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/vedacoes/vedacoes-step.component').then(
                (m) => m.VedacoesStepComponent,
              ),
          },
          {
            path: 'carga-inicial',
            data: {
              title: 'Carga Inicial',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Visualizar', url: '' },
                { label: 'Carga Inicial', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/carga-inicial/carga-inicial-step.component').then(
                (m) => m.CargaInicialStepComponent,
              ),
          },
          {
            path: 'selecao-ine',
            data: {
              title: 'Seleção de INE',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Visualizar', url: '' },
                { label: 'Seleção de INE', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/selecao-ine/selecao-ine-step.component').then(
                (m) => m.SelecaoIneStepComponent,
              ),
          },
          {
            path: 'fases',
            data: {
              title: 'Fases',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Visualizar', url: '' },
                { label: 'Fases', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/fases/fases-step.component').then(
                (m) => m.FasesStepComponent,
              ),
          },
          {
            path: 'cronograma',
            data: {
              title: 'Cronograma',
              roles: [Role.CRONOGRAMA_CONSULTAR],
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Visualizar', url: '' },
                { label: 'Cronograma', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/cronograma/cronograma-step.component').then(
                (m) => m.CronogramaStepComponent,
              ),
          },
          {
            path: 'documentos',
            data: {
              title: 'Documentos',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Visualizar', url: '' },
                { label: 'Documentos', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/documentos/documentos-fases-etapas-step.component').then(
                (m) => m.DocumentoFaseEtapaStepComponent,
              ),
          },
          {
            path: 'perguntas',
            data: {
              title: 'Perguntas',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Visualizar', url: '' },
                { label: 'Perguntas', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/perguntas/perguntas-step.component').then(
                (m) => m.PerguntasStepComponent,
              ),
          },
          {
            path: 'barema',
            children: [
              {
                path: '',
                data: {
                  title: 'Barema',
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Visualizar', url: '' },
                    { label: 'Barema', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('./steps/barema/barema-step.component').then(
                    (m) => m.BaremaStepComponent,
                  ),
              },
              {
                path: 'item/:itemId/profissionais',
                data: {
                  title: 'Profissionais por Item',
                  roles: [Role.BAREMA_CONSULTAR],
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Visualizar', url: '' },
                    { label: 'Barema', url: '' },
                    { label: 'Profissionais por Item', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('../gerenciar-barema/profissionais-por-item/profissionais-por-item.component').then(
                    (m) => m.ProfissionaisPorItemComponent,
                  ),
              },
              {
                path: 'item/:itemId/upload/:uploadId/profissionais',
                data: {
                  title: 'Profissionais Identificados',
                  roles: [Role.BAREMA_CONSULTAR],
                  breadcrumb: [
                    { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                    { label: 'Visualizar', url: '' },
                    { label: 'Barema', url: '' },
                    { label: 'Profissionais Identificados', url: '' },
                  ],
                },
                loadComponent: () =>
                  import('../gerenciar-barema/profissionais-identificados/profissionais-identificados.component').then(
                    (m) => m.ProfissionaisIdentificadosComponent,
                  ),
              },
            ],
          },
          {
            path: 'final',
            data: {
              title: 'Final',
              breadcrumb: [
                { label: 'Parametrização de Editais', url: '/parametrizacao-editais' },
                { label: 'Visualizar', url: '' },
                { label: 'Final', url: '' },
              ],
            },
            loadComponent: () =>
              import('./steps/final/final-step.component').then(
                (m) => m.FinalStepComponent,
              ),
          },
        ],
      },
    ],
  },
];
